import styled from 'styled-components';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    position: 'relative',
    display: 'flex',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Dropdown/StyledComponents/DropdownInnerWrapper.tsx